/**
 * Zeichnen wir gerade für den Hauptnutzer? (16.09.2026)
 *
 * ## Warum das eine eigene Datei ist
 *
 * Martin sieht auf Alberts Seite Dinge, die nur ihn angehen — den Modellnamen
 * in der Statuszeile (*„bi kann er gar nicht nutzen"*), den Anbieter-Vergleich
 * beim Klang des Tages (*„die anderen ein A/B bitte ausblenden"*), die Knöpfe
 * zum Erzeugen weiterer Musik.
 *
 * Die Bausteine, die das zeichnen, liegen in `lib/` und kennen `currentUser`
 * nicht. Sie fragen deshalb das Blatt: `app.ts` setzt beim Anmelden die Marke
 * `data-hauptnutzer` und nimmt sie sonst weg.
 *
 * ⚠️ Die Frage stand kurz in `zuhause-lage.ts` — dort ist sie falsch
 *    aufgehoben: ein Klang-Block hat mit der Lage-Zeile nichts zu tun und
 *    sollte sie nicht importieren müssen. Eine Frage, die mehrere stellen,
 *    gehört an einen eigenen Ort.
 *
 * ⚠️ Der sparsame Fall ist die VORGABE: fehlt die Marke, gilt „kein
 *    Hauptnutzer". Wer sie vergisst, zeigt zu wenig — nie zu viel, und nie
 *    einen Knopf, der Geld kostet.
 */
export function istHauptnutzer(): boolean {
  try {
    return document.body.dataset.hauptnutzer === "ja";
  } catch {
    return false;
  }
}
